<template>
    <b-card>
        <b-tabs>
            <b-tab
                v-for="language in languages"
                :title="language.code.toUpperCase()"
            >
                <b-form-group
                    :label="$t('Component(Label):content')"
                    :label-for="'content' + language.code"
                >
                    <quill-editor
                        :id="'content' + language.code"
                        v-model="content.translations[language.code].content"
                    />
                </b-form-group>
            </b-tab>
        </b-tabs>
        <div class="text-right">
            <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="primary"
                class="mr-1"
                @click="save"
            >
                {{ $t('Component(Button):save') }}
            </b-button>

            <b-button
                v-ripple.400="'rgba(40, 199, 111, 0.15)'"
                variant="primary"
                @click="close"
            >
                {{ $t('Component(Button):close') }}
            </b-button>
        </div>
    </b-card>
</template>

<script>
import {BButton, BTabs, BTab, BCard, BFormGroup, BFormInput} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {i18nApi, PagesApi} from "@core/api";
import {required} from '@validations'
import Ripple from 'vue-ripple-directive'
import { quillEditor } from 'vue-quill-editor'

export default {
    directives: {Ripple},
    components: {
        BButton, BTabs, BTab, BCard, ValidationProvider, ValidationObserver, BFormGroup, BFormInput, quillEditor
    },
    props: {
        id: {
            required: true
        }
    },
    data() {
        return {
            languages: [],
            content: {
                translations: {}
            },
            required,
        };
    },
    methods: {
        save() {
            PagesApi.updateSystemContent(this.id, this.content).then(this.gotoTheGrid);
        },
        close() {
            this.gotoTheGrid();
        },
        gotoTheGrid() {
            this.$router.push({name: 'administration-pages-system-articles'});
        }
    },
    created() {
        PagesApi
            .getSystemContent(this.id)
            .then(r => {
                if (typeof r.data.translations === 'object' && !Array.isArray(r.data.translations)) {
                    this.content.translations = r.data.translations
                }
            });
        i18nApi.getLanguages().then(r => {
            r.data.forEach(language => {
                if (this.content.translations[language.code] === undefined) {
                    this.$set(this.content.translations, language.code, {content: ''});
                }
            });
            this.languages = r.data
        });
    }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>
